export default {
	er_cover_default_title: 'Přehled výkonu',
	er_page_success_metrics: 'Co se tento měsíc změnilo',
	er_page_success_metrics_range: 'Co se v tomto období změnilo',
	er_page_success_metrics_week: 'Co se tento týden změnilo',
	er_page_comparison: 'Srovnávací souhrn',
	er_page_period_summary: 'Souhrn měsíce',
	er_page_period_summary_range: 'Souhrn období',
	er_page_period_summary_week: 'Souhrn týdne',
	er_page_each_month: 'Každý měsíc',
	er_page_rooms: 'Místnosti',
	er_rooms_note: 'Každá místnost v {month}, nejlepší skóre první.',
	er_page_shift_comparison: 'Srovnání podle směny',
	er_page_shift_summary: 'Podle směny',
	er_page_response_time: 'Průměrná doba odezvy (min)',
	er_page_avg_score: 'Skóre zážitku',
	er_page_complaints_vs_visits: 'Stížnosti vs návštěvy',
	er_page_performance_trends: 'Trendy výkonu',
	er_page_complaint_drivers: 'Příčiny stížností',

	er_board_working: 'Lepší než {month}',
	er_board_attention: 'Vyžaduje pozornost oproti {month}',
	er_board_empty: 'Tento měsíc nejsou žádné podstatné změny.',
	er_board_empty_range: 'V tomto období nejsou žádné podstatné změny.',
	er_board_empty_week: 'Tento týden nejsou žádné podstatné změny.',
	er_findings_intro: 'Srovnání s {month}. Zobrazují se jen podstatné změny.',
	er_verdict_improved: 'Zlepšení',
	er_verdict_watch: 'Vyžaduje pozornost',

	er_col_metric: 'Ukazatel',
	er_col_avg: 'Prům. YTD',
	er_col_lifetime_avg: 'Prům. od začátku',
	er_comparison_note: 'Prům. YTD je údaj od ledna do {month}.',
	er_lifetime_note: 'Od začátku je měsíční průměr od prvního dne s daty do {month}.',
	er_comparison_note_week: 'Týden reportu se porovnává s vybraným předchozím týdnem.',
	er_period_only_note: 'Údaje platí pouze pro {month}.',
	er_each_month_note: 'Každý měsíc ve zvoleném období. Měsíc bez dat zůstane prázdný.',
	er_col_inc_dec: 'Změna',
	er_col_complaint: 'Stížnost',
	er_col_qty: 'Počet',
	er_total: 'Celkem',

	er_metric_avg_score: 'Skóre zážitku',
	er_metric_avg_response_time: 'Průměrná doba odezvy',
	er_metric_cleaner_arrivals: 'Příchody úklidu',
	er_metric_supervisor_inspections: 'Kontroly supervisorů',
	er_metric_complaints_vs_visits_pct: 'Stížnosti vs. návštěvy (%)',
	er_metric_complaints: 'Stížnosti',
	er_metric_customer_visits: 'Návštěvy',
	er_metric_expired_slas: 'Vypršené SLA',
	er_unit_min: 'min',
	er_stat_expected_sla: 'Očekávané SLA',
	er_stat_vs_minutes: 'oproti {value} v {month}',
	er_stat_vs_count: 'oproti {value} v {month}',
	er_label_complaints: 'Stížnosti',
	er_label_visits: 'Návštěvy',
	er_label_complaints_per_visits: 'Stížnosti / návštěvy',
	er_chart_ratio: 'Poměr stížností k návštěvám',
	er_chart_ytd_window: 'Od ledna do {month}.',
	er_cv_formula: 'Stížnosti dělené návštěvami toalet, v procentech: ({complaints} ÷ {visits}) × 100 = {ratio} % v {month}.',
	er_export_kpis_title: 'Co report obsahuje',
	er_export_kpis_desc: 'Všechno toto je v reportu. Vypněte položku, kterou nechcete.',
	er_export_select_all: 'Vybrat vše',
	er_export_clear_all: 'Zrušit výběr',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Období reportu',
	er_export_grain: 'Sestavit podle',
	er_export_grain_month: 'Měsíc',
	er_export_grain_week: 'Týden',
	er_export_week_starts: 'Týden začíná',
	er_export_week_starts_sunday: 'nedělí',
	er_export_week_starts_monday: 'pondělím',
	er_export_report_month: 'Měsíc reportu',
	er_export_from_month: 'Od',
	er_export_to_month: 'Do',
	er_export_period_note_range: 'Report sčítá každý měsíc od začátku do konce. Při zapnutém porovnání se použije předchozí období stejné délky. Údaje od začátku roku stále jdou od ledna do koncového měsíce.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'Předchozí období stejné délky.',
	er_export_report_week: 'Týden reportu',
	er_export_compare_month: 'Porovnat s',
	er_export_shift: 'Směna',
	er_export_shift_all: 'Všechny směny',
	er_export_no_shifts: 'Toto místo nemá žádné aktivní směny.',
	er_export_render_failed: 'Přehled se nepodařilo správně vykreslit, proto se nestáhl. Obnovte stránku a zkuste to znovu.',
	er_export_comparison: 'Srovnání',
	er_export_include_previous: 'Zahrnout předchozí období',
	er_export_comparison_on: 'Zapnuto',
	er_export_comparison_off: 'Vypnuto',
	er_export_no_previous_data: 'Před tímto obdobím nejsou žádná data, takže není s čím porovnávat.',
	er_export_compare_previous: 'Předchozí měsíc',
	er_export_compare_previous_week: 'Předchozí týden',
	er_export_compare_last_year: 'Stejný měsíc loni',
	er_export_no_periods: 'Tento objekt potřebuje alespoň jeden měsíc dat, než lze report exportovat.',
	er_export_no_periods_week: 'Tento objekt potřebuje alespoň jeden týden dat, než lze report exportovat.',
	er_export_period_note: 'Zobrazují se jen měsíce s daty. Údaje od začátku roku vždy zahrnují leden až měsíc reportu.',
	er_export_period_note_week: 'Zobrazují se jen týdny s daty. Srovnání je vždy s dřívějším týdnem.',
	er_export_period_note_single_week: 'Zobrazují se jen týdny s daty.',

	er_find_response_time_title: 'Průměrná doba odezvy',
	er_find_response_time_change:
		'Změnilo se z {previous} na {current} minut ({change}).',
	er_find_avg_score_title: 'Skóre zážitku',
	er_find_score_eased: 'Kleslo z {previous} na {current}.',
	er_find_score_improved: 'Stouplo z {previous} na {current}.',
	er_find_score_ytd_inline: 'Odpovídá průměru od začátku roku {ytd}.',
	er_find_score_ytd_inline_range: 'Shoduje se s průměrem od ledna do {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Průměr od začátku roku: {ytd}.',
	er_find_score_ytd_against_range: 'Průměr od ledna do {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Poměr stížností k návštěvám',
	er_find_complaints_ratio_improved: 'Zlepšilo se z {previous} na {current}.',
	er_find_complaints_ratio_rose: 'Změnilo se z {previous} na {current}.',

	er_nar_cv_year_improved: 'Stížnosti vůči návštěvám toalet se během roku zlepšily z {from} na {to}.',
	er_nar_cv_year_rose: 'Stížnosti vůči návštěvám toalet během roku vzrostly z {from} na {to}.',
	er_nar_cv_moved: 'Stížnosti vůči návštěvám toalet se změnily z {previous} na {current}.',
	er_nar_cv_current: 'Stížnosti vůči návštěvám toalet jsou na úrovni {current}.',
	er_nar_types_total: 'Celkem stížností {total}.',
	er_nar_types_1: 'Nejčastější stížnost: {a} ({ap} %).',
	er_nar_types_2: 'Nejčastější stížnost: {a} ({ap} %), následuje {b} ({bp} %).',
	er_nar_types_3: 'Nejčastější stížnost: {a} ({ap} %), následuje {b} ({bp} %) a {c} ({cp} %).',
	er_find_rooms_slowest: 'Místnosti s nejdelší dobou odezvy tento měsíc: {rooms}.',
	er_find_rooms_slowest_range: 'Místnosti s nejdelší dobou odezvy v tomto období: {rooms}.',
	er_find_rooms_slowest_week: 'Místnosti s nejdelší dobou odezvy tento týden: {rooms}.',
	er_find_rooms_lowest_score: 'Místnosti s nejnižším skóre tento měsíc: {rooms}.',
	er_find_rooms_lowest_score_range: 'Místnosti s nejnižším skóre v tomto období: {rooms}.',
	er_find_rooms_lowest_score_week: 'Místnosti s nejnižším skóre tento týden: {rooms}.',

	er_find_so_what_ratio: 'Většina změny pocházela z {rooms}.',
	er_find_so_what_type: 'Hlavní stížnost: {name} ({percent}%).',
	er_hot_slowest: 'Místnosti s nejdelší dobou odezvy',
	er_hot_expired_slas: 'Místnosti, které překročily SLA',
	er_hot_ratio: 'Místnosti s největší změnou míry stížností',
	er_hot_top_type: 'Místnosti s nejvíce stížnostmi typu „{name}“',
	er_hot_col_room: 'Místnost',
	er_col_response: 'Odezva',
	er_col_cleaners: 'Úklid',
	er_col_score: 'Skóre',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Poměr',
	er_hot_col_change: 'Změna',
	er_hot_col_count: 'Počet',
	er_hot_empty: 'Tento měsíc nejsou žádné místnosti k vyzdvižení.',
	er_hot_empty_range: 'V tomto období nejsou žádné místnosti k vyzdvižení.',
	er_hot_empty_week: 'Tento týden nejsou žádné místnosti k vyzdvižení.',
	er_cover_highlights: 'Tento měsíc',
	er_cover_highlights_range: 'Toto období',
	er_cover_highlights_week: 'Tento týden',
	er_cover_score_rose: 'Skóre zážitku vzrostlo.',
	er_cover_score_eased: 'Skóre zážitku kleslo.',
	er_cover_response_improved: 'Doba odezvy se zlepšila.',
	er_cover_response_slowed: 'Doba odezvy se prodloužila.',
	er_cover_ratio_fell: 'Poměr stížností k návštěvám klesl.',
	er_cover_ratio_rose: 'Poměr stížností k návštěvám vzrostl.',
	er_export_pdf: 'PDF přehledu',
	er_export_executive: 'Manažerská zpráva',
	'executive-report': 'Manažerská zpráva',
	er_export_csv: 'CSV',
	er_export_status_title: 'Vytváříme report',
	er_export_status_fetch: 'Načítáme čísla',
	er_export_status_layout: 'Připravujeme stránky',
	er_export_status_page: 'Stránka {page} z {total}',
	er_footer_copyright: 'Tento report byl vygenerován prostřednictvím systému BuzzzTech.',
	er_contact_line: 'Máte otázky nebo chcete data prozkoumat podrobněji? Kontaktujte tým Customer Success BuzzzTech: {email} nebo {phone}.',
};
